import React, { useState } from 'react';
import styles from './styles.module.scss';
import { ConsentState } from '../../types';

const PRIVACY_URL = 'https://www.enpal.com/it/protezione-dei-dati';

interface SuccessSlideProps {
  consents: ConsentState;
  onConsentsChange: (consents: ConsentState) => void;
  amountLabel?: string | null;
}

const SuccessSlide: React.FC<SuccessSlideProps> = ({ consents, onConsentsChange, amountLabel }) => {
  const [editingPartner, setEditingPartner] = useState(false);

  return (
    <section className={styles.preferences}>
      <h2 className={styles.thankYou} tabIndex={-1} data-step-title>
        {amountLabel ? (
          <>
            Grazie, per la tua caldaia puoi ricevere fino a <span className={styles.amount}>{amountLabel}</span>
            <span className={styles.punct}>.</span>
          </>
        ) : (
          <>
            Grazie, ti chiamiamo a breve per il valore della tua caldaia
            <span className={styles.punct}>.</span>
          </>
        )}
      </h2>
      <p className={styles.confirmNote}>Ti chiamiamo a breve per confermare il valore.</p>
      <h4 className={styles.preferencesTitle}>Le tue preferenze</h4>
      <p className={styles.preferencesHint}>Facoltativi, revocabili in ogni momento</p>

      <div className={styles.preferenceActions}>
        <button
          type="button"
          className={styles.preferenceBulk}
          onClick={() =>
            onConsentsChange({
              ...consents,
              enpalMarketingConsent: false,
              thirdPartyProfiling: false,
            })
          }
        >
          Deseleziona tutti
        </button>
        <button
          type="button"
          className={styles.preferenceBulk}
          onClick={() =>
            onConsentsChange({
              ...consents,
              enpalMarketingConsent: true,
              thirdPartyProfiling: true,
            })
          }
        >
          Seleziona tutti
        </button>
      </div>

      <label className={styles.preferenceCard}>
        <span className={styles.preferenceCardTop}>
          <span className={styles.preferenceName}>Offerte e novità Enpal</span>
          <input
            type="checkbox"
            className={styles.preferenceCheckbox}
            checked={consents.enpalMarketingConsent}
            onChange={() =>
              onConsentsChange({
                ...consents,
                enpalMarketingConsent: !consents.enpalMarketingConsent,
              })
            }
          />
        </span>
        <span className={styles.preferenceText}>
          Acconsento a ricevere offerte e novità da Enpal Italia via email, SMS, WhatsApp e telefono.
        </span>
      </label>

      <label className={styles.preferenceCard}>
        <span className={styles.preferenceCardTop}>
          <span className={styles.preferenceName}>Proposte su misura (profilazione)</span>
          <input
            type="checkbox"
            className={styles.preferenceCheckbox}
            checked={consents.thirdPartyProfiling}
            onChange={() =>
              onConsentsChange({
                ...consents,
                thirdPartyProfiling: !consents.thirdPartyProfiling,
              })
            }
          />
        </span>
        <span className={styles.preferenceText}>
          Acconsento che Enpal Italia usi consumi, dati dell&apos;immobile e interazioni per propormi offerte su misura.
        </span>
      </label>

      <div className={styles.partnerRow}>
        <span>
          Dati ai partner: <strong>{consents.thirdPartyMarketing ? 'Sì' : 'No'}</strong>
        </span>
        <button
          type="button"
          className={styles.modifyLink}
          onClick={() => setEditingPartner((open) => !open)}
        >
          Modifica
        </button>
      </div>

      {editingPartner && (
        <label className={styles.preferenceCard}>
          <span className={styles.preferenceCardTop}>
            <span className={styles.preferenceName}>Comunicazione dei dati ai partner</span>
            <input
              type="checkbox"
              className={styles.preferenceCheckbox}
              checked={consents.thirdPartyMarketing}
              onChange={() =>
                onConsentsChange({
                  ...consents,
                  thirdPartyMarketing: !consents.thirdPartyMarketing,
                })
              }
            />
          </span>
          <span className={styles.preferenceText}>
            Acconsento a comunicare i miei dati ai partner in{' '}
            <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">
              elenco
            </a>
            , per ricevere le loro offerte. Agiscono come titolari autonomi.
          </span>
        </label>
      )}
    </section>
  );
};

export default SuccessSlide;
